import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.commons')
  .factory('LocationAPI', LocationAPI);

function LocationAPI(): BringozApi {
  return {
    base: `/location`,
    infiniteScroll: {
      address: `/location`,
      cmd: 'GET'
    },
    actions: {
      getLocations: {
        address: '',
        cmd: 'POST',
        updateable: true
      },
      getAgentLocation: {
        address: 'Agent/{id}',
        cmd: 'GET',
        updateable: true
      },
      getLogisticsVehicleLocation: {
        address: 'LogisticsVehicle/{id}',
        cmd: 'GET',
        updateable: true
      }
    }
  }
}
